import Siema from "siema";

function main() {
  const dots = document.querySelectorAll('.pagination-dot');
  const imgSlider = document.querySelector('.events-img-slider');
  const slideLength = document.querySelectorAll('.events-img-slider .events-img-slide').length

  if ( slideLength > 1 ) {
    initFeatureSlider()
  } else {
    imgSlider.parentElement.classList.add('no-siema-slider')
  }

  function initFeatureSlider() {
    const bgSlider = new Siema({
      selector: ".events-img-slider",
      duration: 600,
      easing: "cubic-bezier(0.77, 0, 0.175, 1)",
      perPage: 1,
      startIndex: 0,
      draggable: false,
      threshold: 20,
      loop: true,
      rtl: false,
      onInit: () => {},
      onChange: () => {}
    });
  
    const detailsSlider = new Siema({
      selector: ".events-details-slider",
      duration: 600,
      easing: "cubic-bezier(0.77, 0, 0.175, 1)",
      perPage: 1,
      startIndex: 0,
      draggable: false,
      threshold: 20,
      loop: true,
      rtl: false,
      onInit: () => {},
      onChange: () => {
        dots.forEach(d => d.classList.remove('is-active'));    
        dots[bgSlider.currentSlide].classList.add('is-active');    
      }
    });
  
    document.querySelector(".events-right-btn").addEventListener("click", () => {
      bgSlider.next();
  
      setTimeout(() => detailsSlider.next(), 75);
    });
  
    document.querySelector(".events-left-btn").addEventListener("click", () => {
      bgSlider.prev();
  
      setTimeout(() => detailsSlider.prev(), 75);
    });
  
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        bgSlider.goTo(index);
        detailsSlider.goTo(index);
      })
    })
  }
}

export default main;
